import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  Users,
  EnvelopeSimple,
  ChatCircleDots,
  Bell,
  Article,
  PencilSimple,
  Coins,
  ArrowRight,
  ListMagnifyingGlass,
} from "@phosphor-icons/react";
import api from "@/lib/api";

export default function AdminOverview() {
  const [stats, setStats] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api
      .get("/admin/stats")
      .then((r) => setStats(r.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const cards = [
    { k: "users", label: "Users", icon: Users, tone: "text-[#3B5BDB]" },
    { k: "waitlist", label: "Waitlist", icon: EnvelopeSimple, tone: "text-[#D4AF37]" },
    { k: "conversations", label: "Conversations", icon: ChatCircleDots, tone: "text-[#5C3EC2]" },
    { k: "active_alerts", label: "Active alerts", icon: Bell, tone: "text-[#16A34A]" },
    { k: "posts_published", label: "Posts published", icon: Article, tone: "text-[#3B5BDB]" },
    { k: "posts_drafts", label: "Drafts", icon: PencilSimple, tone: "text-[#4A5568]" },
  ];

  return (
    <div data-testid="admin-overview">
      <p className="text-xs uppercase tracking-[0.25em] text-[#3B5BDB] font-semibold">
        Overview
      </p>
      <h1 className="font-display text-3xl sm:text-4xl mt-2 text-[#0A1128]">
        Mine AI control room
      </h1>

      <div className="mt-8 grid grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-5">
        {cards.map((c) => (
          <div key={c.k} className="mc-card p-5" data-testid={`stat-${c.k}`}>
            <c.icon size={22} weight="duotone" className={c.tone} />
            <p className="text-xs uppercase tracking-wider text-[#4A5568] mt-3">
              {c.label}
            </p>
            <p className="font-display text-3xl text-[#0A1128] mt-1 tabular-nums">
              {loading ? "—" : (stats?.[c.k] ?? 0).toLocaleString("en-IN")}
            </p>
          </div>
        ))}
      </div>

      <div className="mt-10 grid sm:grid-cols-3 gap-5">
        <Link
          to="/admin/board-rates"
          className="mc-card p-6 lift smooth flex items-center justify-between"
          data-testid="quick-board-rates"
        >
          <div>
            <Coins size={24} weight="duotone" className="text-[#D4AF37]" />
            <p className="font-display text-xl mt-3">Update Board Rates</p>
            <p className="text-sm text-[#4A5568] mt-1">
              Set today's city-wise gold and silver rates.
            </p>
          </div>
          <ArrowRight size={20} className="text-[#3B5BDB]" />
        </Link>
        <Link
          to="/admin/posts"
          className="mc-card p-6 lift smooth flex items-center justify-between"
          data-testid="quick-posts"
        >
          <div>
            <Article size={24} weight="duotone" className="text-[#3B5BDB]" />
            <p className="font-display text-xl mt-3">Manage Posts</p>
            <p className="text-sm text-[#4A5568] mt-1">
              Write announcements, blog posts, or buying guides.
            </p>
          </div>
          <ArrowRight size={20} className="text-[#3B5BDB]" />
        </Link>
        <Link
          to="/admin/audit-logs"
          className="mc-card p-6 lift smooth flex items-center justify-between"
          data-testid="quick-audit"
        >
          <div>
            <ListMagnifyingGlass size={24} weight="duotone" className="text-[#5C3EC2]" />
            <p className="font-display text-xl mt-3">Audit Log</p>
            <p className="text-sm text-[#4A5568] mt-1">
              See who changed what — every admin action recorded.
            </p>
          </div>
          <ArrowRight size={20} className="text-[#3B5BDB]" />
        </Link>
      </div>
    </div>
  );
}
